import type { RefusalNotifiableConfig } from '@/api/api';
import type {
    CommentThreadReply,
    CommentThreadReplyRequest,
    ReviewAnswerCommentThreads,
} from '@/types/review/CommentThread';

import { api } from '@/api/api';

export default {
    async getCommentThreads(threadKey: string): Promise<ReviewAnswerCommentThreads> {
        const response = await api.get(`/commentthread/${threadKey}`);

        return response.data;
    },

    async replyInCommentThread({
        threadKey,
        request,
    }: {
        threadKey: string;
        request: CommentThreadReplyRequest;
    }): Promise<CommentThreadReply> {
        // The page says what a refusal means for the reply, which the generic toast cannot.
        const response = await api.post(`/commentthread/${threadKey}/replies`, request, {
            notifyOnRefusal: false,
        } as RefusalNotifiableConfig);

        return response.data;
    },
};
